var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThankyouIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 310,
    viewBox: "0 0 648 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M647.73 55.7318L549.865 64.7919L573.592 77.2797L573.963 100.263L594.409 88.2121L605.898 94.2231L647.73 55.7318Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M572.097 98.8685L571.555 65.2966L645.864 54.3377L572.097 98.8685Z",
    fill: "url(#paint0_linear_2830_3985)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M571.887 75.9702C572.263 75.839 645.865 54.3377 645.865 54.3377L548 63.3985L571.887 75.9702Z",
    fill: "url(#paint1_linear_2830_3985)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M579.999 80.2551L572.098 98.8685L605.987 78.8954L579.999 80.2551Z",
    fill: "#643DEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M580 80.2551L604.034 92.8296L645.865 54.3377L580 80.2551Z",
    fill: "url(#paint2_linear_2830_3985)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1645 292.437C87.3566 318.246 148.815 298.334 172.145 285.152L191.643 186.289C217.639 227.916 289.33 310.857 368.119 309.608C466.606 308.047 485.104 264.859 489.603 230.517C494.102 196.175 460.107 169.118 400.615 162.354C341.123 155.589 344.622 112.922 330.624 85.8646C295.629 0.52979 244.635 0.529793 218.139 0.00945876C191.643 -0.510875 127.651 20.3025 112.153 95.7509C96.6551 171.199 78.6577 174.321 28.1645 205.541C-22.3288 236.761 6.16737 285.152 28.1645 292.437Z",
    fill: "#F3F1FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.56001,
    height: 28.7166,
    rx: 2.78001,
    transform: "matrix(-0.73235 -0.680928 0.886945 -0.461875 377.074 116.172)",
    fill: "#D1B4FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.85428,
    height: 33.5605,
    rx: 2.92714,
    transform: "matrix(0.820836 -0.571165 0.820836 0.571165 369.004 265.805)",
    fill: "#A978FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.85428,
    height: 25.4858,
    rx: 2.92714,
    transform: "matrix(0.419764 -0.907633 0.996941 0.0781573 383.219 247.901)",
    fill: "#DFD1FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.85428,
    height: 27.4051,
    rx: 2.92714,
    transform: "matrix(-0.820836 -0.571165 0.820836 -0.571165 76.8086 275.306)",
    fill: "#DFD1FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.34343,
    height: 24.9057,
    rx: 3.17171,
    transform: "matrix(-0.928076 -0.37239 0.638082 -0.769969 357.889 100.482)",
    fill: "#6824FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6.33731,
    height: 24.9398,
    rx: 3.16865,
    transform: "matrix(-0.926954 0.375175 -0.641356 -0.767244 98.8711 98.0782)",
    fill: "#6824FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4.73861,
    height: 31.7808,
    rx: 2.36931,
    transform: "matrix(0.0896249 0.995976 -0.999052 0.043529 71.752 140.177)",
    fill: "#6824FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 5.48751,
    height: 29.0206,
    rx: 2.74376,
    transform: "matrix(-0.706426 0.707787 -0.900378 -0.43511 80.0059 113.838)",
    fill: "#D1B4FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2830_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.789 76.9695C238.53 73.5709 231.455 73.5732 226.196 76.9695L118.008 146.899L118.246 277.895L351.713 278.297L351.786 146.728L243.789 76.9695Z",
    fill: "url(#paint3_linear_2830_3985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.224 88.0128H161.569C154.777 88.0128 149.27 94.3275 149.27 102.116V239.049C149.27 246.838 154.777 253.152 161.569 253.152H308.226C315.018 253.152 320.525 246.838 320.525 239.049V102.116C320.523 94.3275 315.016 88.0128 308.224 88.0128Z",
    fill: "#FDFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.786 146.728L351.713 278.297H118.008V146.899L234.884 231.268L351.786 146.728Z",
    fill: "url(#paint4_linear_2830_3985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.048 208.903L118.539 278.297H351.713L243.719 208.903C238.147 205.273 230.62 205.273 225.048 208.903Z",
    fill: "url(#paint5_linear_2830_3985)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.006,
    y: 177.718,
    width: 6.79586,
    height: 93.7829,
    rx: 3.39793,
    transform: "rotate(-90 188.006 177.718)",
    fill: "#DEDAFC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.072,
    y: 192.669,
    width: 6.79586,
    height: 51.6486,
    rx: 3.39793,
    transform: "rotate(-90 209.072 192.669)",
    fill: "#DEDAFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2830_3985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.556 98.2066C217.507 98.2066 203.635 112.078 203.635 129.128C203.635 146.177 217.507 160.049 234.556 160.049C251.605 160.049 265.477 146.177 265.477 129.128C265.477 112.078 251.605 98.2066 234.556 98.2066ZM251.838 120.991L232.076 140.597C230.914 141.76 229.054 141.837 227.814 140.675L217.352 131.143C216.112 129.98 216.034 128.043 217.119 126.803C218.282 125.563 220.219 125.485 221.459 126.648L229.751 134.243L247.42 116.573C248.66 115.333 250.598 115.333 251.838 116.573C253.078 117.813 253.078 119.751 251.838 120.991Z",
    fill: "url(#paint6_linear_2830_3985)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M397 192.068C432.167 194.156 501.9 188.867 499.5 151.014C496.5 103.697 442 115.526 442 133.27C442 151.014 488.5 179.543 523.5 143.708C551.5 115.039 566.5 99.5222 570.5 95.3472",
    stroke: "#AB9CFD",
    strokeLinecap: "round",
    strokeDasharray: "7 7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2830_3985",
    x1: 638.134,
    y1: 56.0772,
    x2: 588.135,
    y2: 97.9457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#653DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7954F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2830_3985",
    x1: 596.932,
    y1: 54.3377,
    x2: 596.932,
    y2: 75.9702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9979FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2830_3985",
    x1: 612.933,
    y1: 54.3377,
    x2: 612.933,
    y2: 92.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9979FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A2FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2830_3985",
    x1: 234.897,
    y1: 74.4214,
    x2: 234.897,
    y2: 278.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9074F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2830_3985",
    x1: 118.008,
    y1: 201.844,
    x2: 351.786,
    y2: 201.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279302,
    stopColor: "#BFB2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6956,
    stopColor: "#BFB4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2830_3985",
    x1: 142.473,
    y1: 242.279,
    x2: 351.713,
    y2: 242.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2830_3985",
    x1: 234.556,
    y1: 98.2066,
    x2: 234.556,
    y2: 160.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A385FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2BED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2830_3985"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.008,
    y: 74.421,
    width: 233.778,
    height: 203.876,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2830_3985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.8424,
    height: 61.8424,
    fill: "white",
    transform: "translate(203.635 98.2066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankyouIllustration);
export default __webpack_public_path__ + "static/media/thankyou-illustration.489f8249883beb7efe529c0fe96646d7.svg";
export { ForwardRef as ReactComponent };